import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Store from './redux/Store';
import reportWebVitals from './reportWebVitals';
import JwtInterceptor from './helpers/jwt.interceptor';
import { ToastContextProvider } from './contexts/toast';
import { AuthContextProvider } from './contexts/auth';
import { EnvironmentContextProvider } from './contexts/environment';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { router } from './constants/router/router';
import { StatusContextProvider } from './contexts/status';
import { getConfig } from './helpers/config';

JwtInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={Store}>
      <HashRouter basename={getConfig()?.baseName}>
      {/* <HashRouter> */}
        <ToastContextProvider>
          <EnvironmentContextProvider>
            <AuthContextProvider>
              <StatusContextProvider>
                {router}
              </StatusContextProvider>
            </AuthContextProvider>
          </EnvironmentContextProvider>
        </ToastContextProvider>
      </HashRouter>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
